<template>
  <DefaultLayout>
    <div slot="content">
      <v-dialog v-model="dialogAddScheduler" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary" >
            <v-btn icon dark  @click="dialogAddScheduler = false" >
              <v-icon>fa-thin fa-circle-xmark</v-icon>
            </v-btn>
            <v-toolbar-title>Scheduler</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" id="new-request-send" @click="createScheduler" :loading="createInProgress"><span style="color: white !important;">Save</span></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form ref="schedulerForm">
              <v-subheader>Scheduler settings</v-subheader>
              <v-list-item>
                <v-list-item-action>
                  <v-text-field v-model="name"
                                id="new-request-first-name"
                                class="mr-1"
                                label="Name"
                                type="text"
                                :rules="[validateRequiredRule]">
                  </v-text-field>
                </v-list-item-action>
                <v-list-item-action>
                  <v-select :items="type"
                            id="new-request-template"
                            item-text="text"
                            item-value="value"
                            v-model="selectedType"
                            label="Type"
                            :disabled="editing">
                  </v-select>
                </v-list-item-action>
                <v-list-item-action>
                  <v-text-field v-model="frequency"
                                id="new-request-first-name"
                                class="mr-1"
                                label="Frequency"
                                type="text"
                                :disabled="editing">
                  </v-text-field>
                </v-list-item-action>
                <v-list-item-action>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        label="Start date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="editing"
                        :rules="[validateRequiredRule]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-list-item-action>
                <v-list-item-action>
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endDate"
                        label="End date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[validateRequiredRule]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      no-title
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-list-item-action>
                <v-list-item-action class="mr-5">
                  <v-menu
                    ref="menu"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="time"
                        label="Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="editing"
                        :rules="[validateRequiredRule]"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu4"
                      v-model="time"
                      full-width
                      format="24hr"
                      @click:minute="$refs.menu.save(time)"
                    ></v-time-picker>
                  </v-menu>
                </v-list-item-action>
                <v-list-item-action class="mr-3">
                  <v-select :items="account.users"
                            id="new-request-template"
                            :item-text="userNameText"
                            item-value="userId"
                            v-model="requesterId"
                            label="Requested by user">
                  </v-select>
                </v-list-item-action>
                <v-list-item-action>
                  <v-switch v-model="enable" :disabled="editing" label="Enabled"></v-switch>
                </v-list-item-action>
              </v-list-item>
              <v-subheader>Requested users<v-btn tile text color="blue" id="new-request-send" @click="addUserShow"><span>Add</span></v-btn></v-subheader>
                <v-data-table
                  :headers="headers"
                  :items="users"
                  :items-per-page="5"
                >
                  <template v-slot:item.email="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" :disabled="item.deletion" text icon color="red" @click="deleteUser(item)"><v-icon>fa-solid fa-close</v-icon></v-btn>
                      </template>
                      <span>Delete user</span>
                    </v-tooltip>
                    {{ item.email }}
                  </template>
                  <template v-slot:item.guestRequest="{ item }">
                    <template v-if="item.guestRequest">Yes</template>
                    <template v-else>No</template>
                  </template>
                </v-data-table>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addUserDialog" max-width="600px">
        <v-card>
          <v-card-title>Add recipient</v-card-title>
          <v-form ref="userForm">
            <v-card-text>
              <v-select :items="templates"
                        id="new-request-template"
                        item-text="name"
                        item-value="id"
                        v-model="template"
                        @change="changeTemplate"
                        label="Template Name">
              </v-select>
              <template v-for="r in references">
                <v-text-field :key="r.ordinal"
                              v-model="r.value"
                              :id="`new-request-reference-${r.ordinal}`"
                              :label="r.name"
                              type="text"
                              :rules="[validateRequiredRule]">
                </v-text-field>
              </template>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="fname"
                                id="new-request-first-name"
                                class="mr-1"
                                label="First Name"
                                type="text">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="lname"
                                id="new-request-last-name"
                                label="Last Name"
                                type="text">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="email"
                                id="new-request-email"
                                class="mr-1"
                                label="Email address"
                                type="email"
                                ref="email"
                                :rules="guestRequest ? [validateEmailRuleNotReq] : [validateRequiredRule, validateEmailRule]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="mobile"
                                id="new-request-mobile"
                                label="Mobile number (optional)"
                                type="text"
                                :rules="[validateMobileRule]">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
          <v-card-actions>
            <v-switch class="mr-3" inset v-model="guestRequest" label="Guest request?"></v-switch>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="fa-regular fa-circle-question"></v-icon>
              </template>
              <span>A Guest Request does not require the user to set a password or log in to respond.<br/>
                    These are one-off requests with no option to reject documents or for app user to view submitted data.<br/>
                    It can also be used to create a profile for the dashboard user to <br/>upload data without need to enter email or mobile details.</span>
            </v-tooltip> 
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addUserDialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="addUser()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="d-flex align-center mb-3">
        <div class="title" @click="updateSchedulers">Data Request Scheduler</div>
        <v-spacer></v-spacer>
        <v-btn id="add-profile-template" tile small dark depressed color="blue" @click="newScheduler"><v-icon small left dark>fal fa-pencil-ruler</v-icon>New Scheduler</v-btn>
      </div>
      <v-divider class="mb-5"></v-divider>
      <template v-if="shedulers.list && shedulers.list.length">
        <v-card v-for="t in shedulers.list" :key="t.id" class="mb-10" style="border-radius: 20px !important;">
          <v-card-title>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-if="t.active" v-on="on" small class="mr-2" color="green">fas fa-circle</v-icon>
                <v-icon v-else v-on="on" small class="mr-2" color="red">fas fa-circle</v-icon>
              </template>
              <span v-if="t.active">Scheduler active</span>
              <span v-else>Scheduler disabled</span>
            </v-tooltip>
            Name: {{ t.name }} &nbsp;&nbsp; <span class="grey--text">Created: {{ formatDate(t.dateCreated) }}</span>
            <!-- <p v-if="t.mobile" class="mb-0 text--disabled">&nbsp;&nbsp;&nbsp;{{ t.mobile }}</p> -->
            <v-spacer></v-spacer>
            <v-btn v-if="t.active" tile small text color="blue" @click="disableScheduler(t.id)"><v-icon small dark class="mr-2">fal fa-power-off</v-icon>Disable</v-btn>
            <v-btn v-if="t.active" tile small text color="green" @click="editScheduler(t)"><v-icon small dark class="mr-2">fa-light fa-pen-to-square</v-icon>Edit</v-btn>
            <v-btn v-if="!t.active" tile small text color="green" @click="resumeScheduler(t.id)"><v-icon small dark class="mr-2">fal fa-plug</v-icon>Enable</v-btn>
            <v-btn tile small text color="red" @click="deleteScheduler(t.id)"><v-icon small dark class="mr-2">fal fa-trash-alt</v-icon>Delete</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-10">
            <v-row>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Type</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ getType(t.intervalType) }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Frequency</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.frequency }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Start date and time</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ formatDate(t.startDate) }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">End date</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ formatDate(t.endDate) }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Requested by user</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ getUser(t.requesterId) }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
              </v-col>
            </v-row>
            <br/><br/>
            <v-row class="mt-3 mb-5">
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium"><b>Requested users</b></v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-for="u in t.receivers">
              <v-col sm="12" md="6" lg="4" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Email</v-col>
                  <v-col v-if="u.email != ''" sm="6" class="py-0 body-2">{{ u.email }}&nbsp;</v-col>
                  <v-col v-else sm="6" class="py-0 body-2">--not set--&nbsp;</v-col>
                </v-row>
              </v-col>
              <br/>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Name</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ u.firstName + ' ' + u.lastName }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Guest request</v-col>
                  <v-col v-if="u.guestRequest === true" sm="6" class="py-0 body-2">Yes</v-col>
                  <v-col v-else sm="6" class="py-0 body-2">No</v-col>
                </v-row>
              </v-col>
              <v-col v-if="u.mobile" sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Mobile</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ u.mobile }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </template>
      <div v-if="!shedulers.list" class="text-center pt-12 mt-12 headline font-weight-bold grey--text">
        No Scheduler created
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import {
  SCHEDULLER_GETBYID,
  SCHEDULLER_GETBYGROUPID,
  SCHEDULLER_CREATE,
  SCHEDULLER_STOP,
  SCHEDULLER_RESUME,
  SCHEDULLER_DELETE,
  SCHEDULLER_UPDATE
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';
import { customizableEmailTemplates } from '@/helpers/constants';
import VueQrcode from 'vue-qrcode';
import logoSrc from "../assets/logopv.png";
import logoSrc2 from "../assets/PVQRcodeDraft.png";

export default {
  name: 'scheduler',
  components: {
    DefaultLayout,
    VueQrcode
  },
  data() {
    return {
      name: '',
      users: [],
      headers: [
        { text: 'Email', value: 'email' },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Guest request', value: 'guestRequest' },
      ],
      addUserDialog: false,
      menu2: false,
      menu3: false,
      menu4: false,
      startDate: null,
      endDate: null,
      time: null,
      type: [
        { text: 'Daily', value: 1 },
        { text: 'Weekly', value: 2 },
        { text: 'Monthly', value: 3 }
      ],
      selectedType: 1,
      frequency: 1,
      shedulers: [],
      dialogAddScheduler: false,
      template: null,
      references: [],
      validateRequiredRule: v => !!v || 'This field is required',
      fname:'',
      lname:'',
      email:'',
      mobile:'',
      guestRequest: false,
      message:'',
      validateEmailRule: v => {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(v).toLowerCase()) || 'Please enter valid Email';
      },
      validateMobileRule: v => {
        let regexp = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;
        return (!v || regexp.test(v)) || 'Mobile must contain +country code e.g. +353871234567';
      },
      validateEmailRuleNotReq: v => {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (!v || re.test(String(v).toLowerCase())) || 'Please enter valid Email';
      },
      enable: true,
      createInProgress: false,
      requesterId: null,
      selectedPeriod: 1,
      editing: false,
      schedullerId: null,
    };
  },
  watch: {
    async account() {
      await this.updateSchedulers();
    },
  },
  computed: {
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ account: state => state.organizations.userSelectedAccount }),
    ...mapState({ templates: state => state.profileTemplates.selectedAccountTemplates }),
    ...mapState({ limitations: state => state.organizations.userSelectedOrganization.limitations }),
  },
  methods: {
    GetEmailRules(){
      if(this.guestRequest){
        return [this.validateEmailRule];
      }else{
        return [this.validateRequiredRule, this.validateEmailRule];
      }
    },
    editScheduler(scheduler){
      this.editing = true;
      this.name = scheduler.name;
      this.schedullerId = scheduler.id;
      this.users = scheduler.receivers;
      this.enable = scheduler.active;
      this.requesterId = scheduler.requesterId;
      this.selectedType = scheduler.intervalType;
      this.frequency = scheduler.frequency;
      this.startDate = scheduler.startDate.slice(0, 10);
      this.endDate = scheduler.endDate.slice(0, 10);
      this.time = scheduler.startDate.substring(11, 16);
      this.dialogAddScheduler = true;
    },
    getType(type){
      return this.type.find(x => x.value == type).text;
    },
    formatDate(date){
      return new Date(date).toLocaleString('en-GB', { timeZone: 'UTC' });
    },
    deleteUser(item){
      if(confirm("Remove user?")){
        this.users = this.users.filter(x => x.email != item.email);
      }
    },
    addUserShow(){
      this.changeTemplate();
      this.addUserDialog = true;
    },
    addUser(){
      if (!this.$refs.userForm.validate()) {
        return;
      }
      this.users.push({ references: this.references, email: this.email, firstName: this.fname, lastName: this.lname, mobile: this.mobile, templateId: this.template, guestRequest: this. guestRequest});
      this.references = [];
      this.email = '';
      this.fname = '';
      this.lname = '';
      this.mobile = '';
      this.addUserDialog = false
    },
    async disableScheduler(id){
      if(confirm('Disable scheduler?')){
        await this.$store.dispatch(SCHEDULLER_STOP, { id: id });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Scheduler disabled',
        });
        setTimeout(() => {
          this.updateSchedulers();
        }, 3000);
      }
    },
    async resumeScheduler(id){
      if(confirm('Resume scheduler?')){
        await this.$store.dispatch(SCHEDULLER_RESUME, { id: id });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Scheduler started',
        });
        setTimeout(() => {
          this.updateSchedulers();
        }, 3000);
      }
    },
    async deleteScheduler(id){
      if(confirm('Delete scheduler?')){
        await this.$store.dispatch(SCHEDULLER_DELETE, { id: id });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Scheduler deleted',
        });
        setTimeout(() => {
          this.updateSchedulers();
        }, 3000);
      }
    },
    getUser(id){
      let user = this.account.users.find(_ => _.userId === id);
      if(user){
        return user.firstName + ' ' + user.lastName;
      }
      return 'User not found'
    },
    getTemplateName(templateId){
      if(this.templates && this.templates.length > 0){
        let t = this.templates.find(e => e.id == templateId);
        if(t){
          return t.name
        } 
      }
      return 'Template deleted!'
    },
    async createScheduler(){
      if (!this.$refs.schedulerForm.validate()) {
        return;
      }

      this.createInProgress = true;

      if(this.editing){
        const scheduler = {
          schedullerId: this.schedullerId,
          requesterId:  this.requesterId,
          recipients: this.users,
          endDate: this.endDate + 'T00:00:00.000Z',
          name: this.name
        };
        console.log(scheduler)
        await this.$store.dispatch(SCHEDULLER_UPDATE, scheduler);
        this.createInProgress = false;
        this.dialogAddScheduler = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Scheduler updated',
        });
      }
      else{
        const scheduler = {
          schedullerId: uuidv4(),
          accountId: this.organization.id,
          groupId: this.account.accountId,
          recipients: this.users,
          active: this.enable,
          requesterId:  this.requesterId,
          intervalType: this.selectedType,
          startDate: this.startDate + 'T' + this.time + ':00.000Z',
          endDate: this.endDate + 'T00:00:00.000Z',
          frequency: this.frequency,
          name: this.name
        };

        await this.$store.dispatch(SCHEDULLER_CREATE, scheduler);
        this.createInProgress = false;
        this.dialogAddScheduler = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Scheduler created',
        });
      }

      setTimeout(() => {
        this.updateSchedulers();
      }, 3000);

    },
    changeTemplate() {
      var selectedTemplate = this.templates.find(x => x.id === this.template);
      if(!selectedTemplate){
        selectedTemplate = this.templates[0];
        this.template = selectedTemplate.id;
      }
      this.references = selectedTemplate.references;
    },
    async updateSchedulers() {
      try {
        this.shedulers = await this.$store.dispatch(SCHEDULLER_GETBYGROUPID, this.account.accountId);
        console.log(this.shedulers)
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting Schedulers. Please contact support@planetverify.com',
        });
      }
    },
    newScheduler(){
      this.editing = false;
      this.name = '';
      this.users = [];
      this.enable = true;
      this.selectedType = 1;
      this.frequency = 1;
      this.startDate = null;
      this.endDate = null;
      this.time = null;
      if(this.templates && this.templates.length > 1){
        this.template = this.templates[0].id;
        this.changeTemplate();
      }
      if(this.account.users && this.account.users.length > 1){
        this.requesterId = this.account.users[0].userId;
      }
      this.dialogAddScheduler = true;
    },
    userNameText(item) {
      return item.firstName + ' ' + item.lastName;
    },
  },
  async mounted() {
    await this.updateSchedulers();
  },
}
</script>

<style>
.v-expansion-panels.new-template-options {
  border-radius: 0;
}
.v-expansion-panels.new-template-options .v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panels.new-template-options .v-expansion-panel:not(:first-child)::after {
  border-top: none;
}
.v-expansion-panels.new-template-options .v-expansion-panel-header {
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid rgba(0,0,0,.12);
}
.v-expansion-panels.new-template-options .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
}
</style>
